import { useEffect, useImperativeHandle, useRef, useState } from "react";
import { InputWrapper } from "../form/InputWrapper";
import { parseUtils } from "../../data-parsing/parseUtils";
import { InputTypes } from "../../data-parsing/InputTypes";
import { type } from "@testing-library/user-event/dist/type";
import { format } from "date-fns";

/**
 * Represents a single cell of a table, that can be edited
 * @param
 * @param valueChangeCallBack : the function that gets called so that the parent knows how to handle the change of a value in the cell
 * @returns 
 */
export function DataTableCell({ formRef, inputRef, callBackRef, dataElement, defaultValue, col, valueChangeCallBack }) {

    //The actual value held by the cell
    const [value, setValue] = useState(defaultValue);

    const [isEditable, setIsEditable] = useState(false)
    const changed = useRef(true);

    useImperativeHandle(callBackRef, () => ({
        updateValue() {
            if (formRef?.current) {
                updateValue();
            }
        }
    }));

    //Notify the parent that the cell value changed
    useEffect(() => {
        if (!changed.current) {
            changed.current = true;
            valueChangeCallBack(col, value);
        }
    }, [value]);

    useEffect(() => {
        if (changed.current) {
            changed.current = false;
        }
    }, [isEditable]);

    function handleClick() {
        //If is editable it is changed to "edit mode"
        if (!col?.metadata?.nonEditable) {
            setIsEditable(true);
            changed.current = true;
        }
    }

    function handleSubmit(event) {
        event.preventDefault();
        updateValue();
    }

    function updateValue() {
        let valueList = parseUtils(formRef);
        let newData = [];
        valueList.forEach(listElement => {
            if (Object.keys(listElement).length > 1) {
                newData.push(listElement);
            } else {
                Object.values(listElement).forEach((val) => {
                    newData.push(val);
                })
            }
        })
        setIsEditable(false);
        formRef?.current?.reset();
        if (newData.length <= 0) {
            return;
        }
        if (col.type !== InputTypes.ARRAY/* && !Array.isArray(value)*/) {
            newData = newData[0];
        }
        changed.current = true;
        setValue(newData);
        valueChangeCallBack(col, newData);
    }



    // console.log("DATE MAYBE? ", value)

    return !isEditable ?
        //WIll just show things as not editables
        <div onClick={handleClick} style={{
            width: "100%",
            minHeight: "36px",
            whiteSpace: "pre-line",
            cursor: col?.metadata?.nonEditable ? "not-allowed" : "auto"
        }}>
            <InputWrapper style={{ transition: "none" }} stringified={!isEditable} dataelement={dataElement}
                type={col.metadata.type}
                defaultValue={value}
                setValue={setValue}
                name={col.name} metadata={col.metadata}
            />
        </div> :
        <form ref={formRef} onSubmit={handleSubmit} style={{ width: "100%" }}>
            <InputWrapper ref={inputRef} style={{ transition: "none" }} stringified={!isEditable}
                inline={true} dataelement={dataElement}
                type={col.metadata.type}
                defaultValue={
                    col.metadata.type === InputTypes.DATE && value instanceof Date
                        ? format(value, "dd/MM/yyyy")
                        : value
                } setValue={setValue} name={col.name} metadata={col.metadata}

                doneEditing={() => {
                    setIsEditable(false)
                }} // Added to be able to close datepickers on selection

            />
        </form>
}